module.exports = JBrowseExports["@jbrowse/core/configuration"];